// extracted by mini-css-extract-plugin
export var content = "footer-module--content--15c87";
export var contentButton = "footer-module--contentButton--35e37";
export var contentButtonRow = "footer-module--contentButtonRow--dcc49";
export var contentTitle = "footer-module--contentTitle--9fa6b";
export var contentWrapper = "footer-module--contentWrapper--1ccdf";
export var copyRight = "footer-module--copyRight--f426e";
export var highlightCircle = "footer-module--highlightCircle--65df0";
export var wrapper = "footer-module--wrapper--fa68c";